import dynamic from 'next/dynamic'
import { PropsWithChildren, ReactNode, useReducer } from 'react'

import {
  ModalsContext,
  modalsInitialState,
  modalsReducer,
} from './ModalContext'

const BiddingModalDynamic = dynamic(
  () =>
    import('@web/components/common/BiddingModal/BiddingModal').then(
      ({ BiddingModal }) => BiddingModal
    ),
  { ssr: false }
)

const RegisterModalDynamic = dynamic(
  () =>
    import('@web/components/common/RegisterModal/RegisterModal').then(
      ({ RegisterModal }) => RegisterModal
    ),
  { ssr: false }
)

const LoginModalDynamic = dynamic(
  () =>
    import('@web/components/layout/LoginModal').then(
      ({ LoginModal }) => LoginModal
    ),
  { ssr: false }
)

export const ModalManager = ({ children }: PropsWithChildren) => {
  const [modalState, dispatch] = useReducer(modalsReducer, modalsInitialState)

  let ModalComponent: ReactNode | null = null

  switch (modalState.modal) {
    case 'BID_NOW':
      ModalComponent = (
        <BiddingModalDynamic
          {...modalState.props}
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )
      break
    case 'REGISTER_NOW':
      ModalComponent = (
        <RegisterModalDynamic
          {...modalState.props}
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )
      break
    case 'LOGIN':
      ModalComponent = (
        <LoginModalDynamic
          {...modalState.props}
          defaultScreen="LOGIN"
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )

      break
    case 'CREATE_ACCOUNT':
      ModalComponent = (
        <LoginModalDynamic
          {...modalState.props}
          defaultScreen="CREATE-ACCOUNT"
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )
      break
    case 'RESET_PASSWORD_COMPLETE':
      ModalComponent = (
        <LoginModalDynamic
          {...modalState.props}
          defaultScreen="COMPLETE-PASSWORD-RESET"
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )
      break
    case 'RESET_PASSWORD':
      ModalComponent = (
        <LoginModalDynamic
          {...modalState.props}
          defaultScreen="PASSWORD"
          setIsOpen={() =>
            dispatch?.({ type: 'CLOSE', payload: modalsInitialState })
          }
        />
      )
      break
  }

  return (
    <ModalsContext.Provider value={{ modalState, dispatch }}>
      {children}
      {ModalComponent}
    </ModalsContext.Provider>
  )
}
